import {sendRequest, serializeObject} from '@js/utils';
import {isMobileOrTablet} from '@js/helpers/screen';
import {
    initRankingFiltersListeners,
    toggleRankingFilters,
} from '@js/modules/public/rankings/institutional/view/components/sidebarFilters';
import {
    initLockFilterYear,
    initSelectsWithLiveSearch,
    initLockExceptTwoYear
} from '@js/modules/public/rankings/institutional/view/helpers';
import initAppliedFiltersListeners from '@js/modules/public/rankings/institutional/view/components/appliedFilters';
import initAutocomplete from '@js/modules/public/rankings/institutional/view/components/autocomplete';
import SidebarInstance from '@js/modules/public/rankings/institutional/view/components/sidebar';
import {initRankingRowShare, highlightViewedOrganization} from '@js/components/shareRankingResult';
import {initCharts} from '@js/modules/public/rankings/institutional/view/components/chart';
import initHeatMap from '@js/modules/public/infographics/charts/heatMap';
import chartErrorsHandler from '@js/helpers/chart';
import initRussiaHeatMap from '@js/modules/public/rankings/institutional/view/components/infographics';
import initCompareRowsListeners from '@js/components/compareRows';
import {
    getRankingId,
    getSearchFormParams,
    refreshPageWithParams,
} from '@js/modules/public/rankings/institutional/view/helpers';
import {lazyloadRows} from '@js/components/ranking/lazyloadRows';
import {appendQueryParam, reloadWithoutGetParams} from '@js/helpers/location';
import {initScrollRankingPage} from "@js/components/ranking/scrollRankingPage";
import {switchTab} from "@js/helpers/tabSwitcher";

let sidebar = null;

$(() => {
    initRankingHandlers();
    initRankingLeagueStatConstructor();
    initSelectsWithLiveSearch();
    initScrollRankingPage();
    if ($('.chart-container').length) {
        import(/* webpackChunkName: "highchart" */'@entries/chart').then(() => {
            initCharts();
        });
    }
    initLockFilterYear();
    initLockExceptTwoYear();

    const urlAnchor = location.hash;
    if (urlAnchor !== '') {
        switchTab(urlAnchor);
    }

    let chartsInitialized = false;
    $('body')
        .on('click', '#main_page_link_to_promo', () => {
            $('body,html').animate({scrollTop: 0}, 300);
            switchTab('#promo');
        })
        .on('click', '.sorting-column', function () {
            const $column = $(this);
            let queryParams = getSearchFormParams();
            const sortingColumn = $column.attr('data-sorting-column');
            const isActiveSortingColumn = $column.hasClass('sorting-column--active');
            let sortingType = $column.closest('table').attr('data-sorting-type');
            if (isActiveSortingColumn) {
                sortingType = sortingType === 'asc' ? 'desc' : 'asc';
            }
            queryParams = appendQueryParam(queryParams, 'sort_by', sortingColumn);
            queryParams = appendQueryParam(queryParams, 'sort_type', sortingType);
            refreshPageWithParams(queryParams);
        })
        .on('click', '#morenews', showMoreNews)
        .on('shown.bs.tab', 'a[data-toggle="tab"]', (e) => {
            document.location.hash = $(e.target).attr("href");
            $('body').animate({scrollTop: 0}, 0);
            if (!chartsInitialized) {
                const $globalRankingHeatMap = $('#heatMapPresenceCountryInRanking');
                const $nationalRankingHeatMap = $('#heatMapPresenceRussiaInRanking');
                if ($globalRankingHeatMap.length || $nationalRankingHeatMap.length) {
                    import(/* webpackChunkName: "highchart" */'@entries/chart').then(() => {
                        const $infographicWrapper = $('.infographic__wrapper');
                        if ($globalRankingHeatMap.length) {
                            const year = $('.ranking-filters [name="year"]').val();
                            sendRequest('get', '/infographics/getStatistic', {year}, (res) => {
                                if (res?.success && res?.data?.stat) {
                                    const chart = initHeatMap(res.data.stat);
                                    reflowInfographicChartIfTabActive(chart);
                                } else {
                                    chartErrorsHandler($infographicWrapper);
                                }
                            });
                        }
                        if ($nationalRankingHeatMap.length) {
                            const year = $('.ranking-filters [name="year"]').val();
                            const data = {
                                year,
                            };
                            const $isFilContainer = $('.ranking-filters [name="is_fil"]');
                            if ($isFilContainer.length) {
                                data.is_fil = $isFilContainer.val();
                            }
                            sendRequest('get', '/infographics/nar/getStatistic', data, (res) => {
                                if (res?.success && res?.data?.stat) {
                                    const chart = initRussiaHeatMap(res.data.stat);
                                    reflowInfographicChartIfTabActive(chart);
                                } else {
                                    chartErrorsHandler($infographicWrapper);
                                }
                            });
                        }
                    });
                }
                chartsInitialized = true;
            }
            $(window).resize();
        });
});

export function showMoreNews() {
    const news = $('body').find('.news .hidden');
    const {countNewsShow} = window;
    let i = 0;
    news.each((number) => {
        if (i < countNewsShow) {
            $(news[number]).removeClass('hidden');
        }
        i += 1;
    });
    if (news.length < countNewsShow) {
        $(this).addClass('hidden');
    }
    if (news.length > 0) {
        event.preventDefault();
        const $lastVisibleNews = $(news[0]);
        $('body').animate({scrollTop: $lastVisibleNews.offset().top - $lastVisibleNews.height()}, '500');
    }
}

function reflowInfographicChartIfTabActive(chart) {
    $('body').on('shown.bs.tab', 'a[href="#infographics"][data-toggle="tab"]', () => {
        chart.reflow();
    });
}

function initRankingLeagueStatConstructor() {
    $('body').on('shown.bs.tab', 'a[href="#methodology"][data-toggle="tab"]', () => {
        const location = '/ratings/national/nacionalnyj-agregirovannyj-rejting/getRankingLeagueStat';
        const data = {
            year: $('.ranking-filters [name="year"]').val(),
            is_fil: $('.ranking-filters [name="is_fil"]').val(),
        };
        sendRequest('get', `${location}`, data, (res) => {
            $('#league_stat_container').html(res.content);
        });
    });
}

function initRankingHandlers() {
    initRankingRowShare($('.ranking-row-share'));
    initRankingFiltersListeners();
    const $autocompleteInput = $('.ranking-filters input[name="name"]');
    if ($autocompleteInput.length) {
        initAutocomplete($autocompleteInput);
    }
    highlightViewedOrganization();
    const $selectsWithLiveSearch = $('.select-with-live-search');
    if ($selectsWithLiveSearch.length) {
        $selectsWithLiveSearch.selectpicker({
            noneResultsText: 'По запросу {0} ничего не найдено',
            noneSelectedText: 'Все',
            size: 15,
        });
    }
    $('body')
        .on('click', '.show-ranking-filters', toggleRankingFilters)
        .on('click', '#clearFilter', reloadWithoutGetParams)
        .on('click', '.show-next-slice-ranking', function () {
            const $showSliceBtn = $(this);
            showNextSliceRanking($showSliceBtn);
        });
    if (!isMobileOrTablet()) {
        sidebar = new SidebarInstance('#sidebar_inner');
    }
    initRankingResultsListeners();
    initAppliedFiltersListeners();
    configureCompareRows();
}

function configureCompareRows() {
    const $resultCompareButtonParent = $('.ranking-results');
    const rankingId = getRankingId();
    const storageKey = `compare.${rankingId}.organizations`;
    initCompareRowsListeners(storageKey, $resultCompareButtonParent, getPrimarySearchFormParams);
}

export function getPrimarySearchFormParams() {
    const params = [];
    const $primaryFilters = $('form.ranking-filters').find('.primary-ranking-filter');
    const $primaryFiltersUgsn = $('form.ranking-filters').find('[name="ugs"]');
    if ($primaryFilters.length) {
        $primaryFilters.each(function () {
            const $filter = $(this);
            params.push(`${$filter.attr('name')}=${$filter.val()}`);
        });
    }
    if ($primaryFiltersUgsn.length) {
        params.push(`${$primaryFiltersUgsn.attr('name')}=${$primaryFiltersUgsn.val()}`);
    }
    const $modeForm = $('#mode-form');
    if ($modeForm.length) {
        params.push($modeForm.serialize());
    }
    return params.join('&');
}

function initRankingResultsListeners() {
    const $tooltips = $('.ranking-results').find('.best-grade');
    $tooltips.each(function (index) {
        const title = `Лучшая оценка<br>${$(this).attr('data-title')}`;
        $(this)
            .tooltip({
                title: title,
                container: 'body',
                placement: 'bottom',
                html: true,
            });
    });
}

export function showNextSliceRanking($showSliceBtn) {
    let pageParam = getSearchFormParams();
    const externalParams = {
        spr_ranking_id: getRankingId(),
    };
    pageParam += `&${serializeObject(externalParams)}`;
    lazyloadRows(pageParam, $showSliceBtn, externalParams.spr_ranking_id)
        .then(() => {
            initRankingRowShare($('.ranking-row-share').not('.jssocials'));
            if (sidebar) {
                sidebar.update();
            }
            initRankingResultsListeners();
            $('[data-toggle="tooltip"]').tooltip();
        });
}
